import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <p className="text-7xl font-heading font-bold text-brand-500">404</p>
        <h1 className="text-2xl font-heading font-bold text-primary mt-4">Page Not Found</h1>
        <p className="text-secondary mt-2">The page you're looking for doesn't exist.</p>
        <Link to="/dashboard"><Button className="mt-6">Go to Dashboard</Button></Link>
      </div>
    </div>
  );
}
